export default __webpack_public_path__ + "static/media/no-data-graph.de0e06e2.svg";